import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { BUY_MOV_POINTS, SOLICITED_CANCEL_BUY_MOV } from './schema.graphql';

@Injectable({
  providedIn: 'root',
})
export class ExchangePointsService {
  constructor(private apollo: Apollo) {}

  extractBuyMovPoints(employeeId: string): Observable<any> {
    return this.apollo.mutate({
      mutation: BUY_MOV_POINTS,
      variables: { employeeId },
    });
  }

  requestCancellation(buyMovId: string): Observable<any> {
    return this.apollo.mutate({
      mutation: SOLICITED_CANCEL_BUY_MOV,
      variables: { buyMovId },
    });
  }
}
